import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import animations from "../../assets/animations";

export type LoadingProps = {
  autoplay?: boolean;
  loop?: boolean;
  src?: object;
  width?: number;
  height?: number;
  controls?: boolean;
};

export const Loading = ({
  autoplay = true,
  loop = true,
  src = animations.Loader,
  width = 200,
  height = 200,
  controls = false,
}: LoadingProps) => {
  return (
    <Player
      autoplay={autoplay}
      loop={loop}
      src={src}
      controls={controls}
      style={{
        width,
        height,
      }}
    />
  );
};

export default Loading;
